import { render, staticRenderFns } from "./changeForm.vue?vue&type=template&id=4dbb4c65&scoped=true&"
import script from "./changeForm.vue?vue&type=script&lang=js&"
export * from "./changeForm.vue?vue&type=script&lang=js&"
import style0 from "./changeForm.vue?vue&type=style&index=0&id=4dbb4c65&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbb4c65",
  null
  
)

export default component.exports